import { useRef } from "react";
import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";

const Background = () => {
  const ref = useRef(null);
  const mx = useMotionValue(0.5);
  const my = useMotionValue(0.5);
  const sx = useSpring(mx, { stiffness: 40, damping: 20 });
  const sy = useSpring(my, { stiffness: 40, damping: 20 });
  const glowX = useTransform(sx, [0, 1], ["-2%", "2%"]);
  const glowY = useTransform(sy, [0, 1], ["-2%", "2%"]);

  const onMouseMove = (e) => {
    const { innerWidth, innerHeight } = window;
    mx.set(e.clientX / innerWidth);
    my.set(e.clientY / innerHeight);
  };

  return (
    <div
      ref={ref}
      onMouseMove={onMouseMove}
      className="fixed -inset-[10%] -z-10 overflow-hidden pointer-events-none"
      aria-hidden="true"
    >
      <motion.div
        className="bg-layer absolute inset-0"
        style={{ x: glowX, y: glowY }}
        initial={false}
        animate={{ scale: [1, 1.08] }}
        transition={{ duration: 14, ease: "easeInOut", repeat: Infinity, repeatType: "reverse" }}
      />
      <motion.div
        className="bg-sweep absolute inset-0"
        initial={false}
        animate={{ x: ["-15%", "15%"] }}
        transition={{ duration: 10, ease: "linear", repeat: Infinity, repeatType: "reverse" }}
      />
    </div>
  );
};

export const Grain = () => (
  <div className="grain fixed inset-0 z-50 pointer-events-none" aria-hidden="true" />
);

export default Background;
